/**
 * 2019-04-08
 * handan
 * 首页请求数据
 */

import { ajax } from "../utils/http/http";
import handleError from "../utils/handleError";

const addBatch = async (params)=>{
  let data = await ajax("/58/batch/add","post",params);
  if(data.code==="1"){
    return Promise.resolve(data.data)
  }else{
    handleError(data);
  }
}

export default addBatch;